import {
  SAMPLE_GET_DATA,
  SAMPLE_GET_DATA_SUCCESS,
  SAMPLE_GET_DATA_ERROR,
  SAMPLE_GET_DATA_LOADING,
} from './types';

// Initial state
const initialState = {
  // Data lists
  data: [],
  total: 0,
  page: 1,
  limit: 10,
};

const sampleReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    // Get Data
    case SAMPLE_GET_DATA:
      newState = { ...state };
      newState.loading = true;
      newState.error = null;
      return newState;

    case SAMPLE_GET_DATA_SUCCESS:
      newState = { ...state };
      newState.data = action.payload.data || action.payload;
      newState.total = action.payload.total || action.payload.length || 0;
      newState.page = action.payload.page || 1;
      newState.limit = action.payload.limit || 10;
      newState.loading = false;
      newState.error = null;
      return newState;

    case SAMPLE_GET_DATA_ERROR:
      newState = { ...state };
      newState.loading = false;
      newState.error = action.payload;
      return newState;

    case SAMPLE_GET_DATA_LOADING:
      newState = { ...state };
      newState.loading = action.payload;
      return newState;

    default:
      return state;
  }
};

export default sampleReducer;
